module.exports = __webpack_public_path__ + "static/media/send.d02f56e3.svg";